module.exports = "<div class=\"type\">\n  <div>\n    {{question_index}}<span class=\"mandatory\" *ngIf=\"is_mandt\">*</span>. {{question_name}}\n  </div>\n  <div>\n    {{question_name_second}}\n  </div>\n  <button (click)=\"clicked()\">FIND ME</button>\n  <div *ngIf=\"map_cord\">{{map_cord}}</div>\n  <div [id]=\"'mapQuestion' + question_index\" [hidden]=\"noLocationAdded\" class=\"mapPortion\"></div>\n  <div *ngIf=\"err.length > 0 \" style=\"color: red\">{{err}}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/map/map-type.component.html
// module id = ./src/app/questions-type/map/map-type.component.html
// module chunks = main